import TownBuyerLandingPage from "./TownBuyerLandingPage";
const VoorheesLanding = () => (
  <TownBuyerLandingPage townName="Voorhees" slug="homes-for-sale-voorhees" savedLinkId="10352" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-voorhees-ac" />
);
export default VoorheesLanding;
